import Http from "../../http/http";
import HttpRequest from "../../http/httpRequest";
import ApiRoutes from "../../http/routes";

export interface SiteLeadData {
  id: number;
  document: string;
  phone: string;
  familyIncome: number;
  propertyValue: number;
  birthDate: number;
  city: string;
  uf: string;
  createdAt: number;
  maxInstallment: number;
  clientAgeInMonths: number;
  maxFinancingTermMonths: number;
  financingValue: number;
  downPayment: number;
}

export interface SiteLeadsResponse {
  totalItems: number;
  data: SiteLeadData[];
}

export default class SiteLeadRepository {
  private static instance: SiteLeadRepository | null = null;

  constructor(private http: Http) {}

  static getInstance(http: Http): SiteLeadRepository {
    if (!SiteLeadRepository.instance) {
      SiteLeadRepository.instance = new SiteLeadRepository(http);
    }
    return SiteLeadRepository.instance;
  }

  async getSiteLeads(): Promise<SiteLeadsResponse> {
    const request = new HttpRequest(ApiRoutes.siteLead);
    return await this.http.get<SiteLeadsResponse>(request);
  }

  async getSiteLeadById(id: string): Promise<SiteLeadData> {
    const request = new HttpRequest(ApiRoutes.siteLeadById.replace("{id}", id));
    return await this.http.get<SiteLeadData>(request);
  }

  async createSiteLead(
    siteLead: Omit<SiteLeadData, "id" | "createdAt">
  ): Promise<SiteLeadData> {
    const request = new HttpRequest(ApiRoutes.siteLead, siteLead);
    return await this.http.post<SiteLeadData>(request);
  }

  async updateSiteLead(
    id: string,
    siteLead: Partial<SiteLeadData>
  ): Promise<SiteLeadData> {
    const request = new HttpRequest(
      ApiRoutes.siteLeadById.replace("{id}", id),
      siteLead
    );
    return await this.http.put<SiteLeadData>(request);
  }

  async deleteSiteLead(id: string): Promise<void> {
    const request = new HttpRequest(ApiRoutes.siteLeadById.replace("{id}", id));
    await this.http.delete(request);
  }
}
